// Settings -- route /settings
//
// Thin wrapper around the canonical SettingsPage from saas-common. All group
// definitions come from the server manifest (GET /api/admin/settings/schema);
// see internal/settings/manifest.go in this project for the registered groups.
//
// If you need a project-specific `kind=custom` panel, import its component and
// pass it via customRegistry={{ "{" }} "my-panel-key": MyPanelComponent {{ "}" }}.

import { SettingsPage } from '@/admin-design/_common/settings'

export default function Settings() {
  return <SettingsPage />
}
